import React from "react";
import {
  makeStyles,
  Box,
  Container,
  Grid,
  Typography,
  Button,
  IconButton,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { AnimationOnScroll } from "react-animation-on-scroll";
const useStyles = makeStyles((theme) => ({
  globeBox: {
    position: "relative",
    zIndex: "9",
    padding: "50px 0",
    "& .globeshadeImg": {
      top: "-59px",
      width: "auto",
      opacity: "0.5",
      zIndex: "-1",
      position: "absolute",
      maxWidth: "800px",
      right: "0",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
      },
    },
    "& .grayText": {
      color: theme.palette.text.secondary,
    },
    "& img": {
      width: "auto",
      maxWidth: "100%",
    },
    "& h2": {
      lineHeight: "60px",
    },
    "& h5": {
      textTransform: "uppercase",
      fontSize: "18px",
      whiteSpace: "pre",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px !important",
      },
    },
    "& .circle": {
      marginRight: "40px",
      [theme.breakpoints.down("xs")]: {
        marginRight: "0px",
      },
    },
    "& .circle1": {
      padding: "59px 0",
    },
    "& .circle2": {
      marginRight: "70px",
      [theme.breakpoints.down("xs")]: {
        marginRight: "0px",
      },
    },
    "& .globecontentBox": {
      background: theme.palette.background.card,
      padding: "15px 30px 15px 30px",
      borderRadius: "50px",
      cursor: "pointer",
      "& img": {
        width: "15px",
        marginLeft: "10px",
      },
    },
  },
}));

function Globe() {
  const classes = useStyles();
  const history = useHistory();
  return (
    <>
      <Box className={classes.globeBox}>
        <img />
        <img
          src="images/road_banner.png"
          alt="images"
          className="globeshadeImg"
        />
        <Box className="ecilipsBox"></Box>
        <Box className="ecilipsBox1"></Box>
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            <Grid item xs={12} lg={5} sm={5} md={5}>
              <img src="images/globe_1.gif" alt="image" />
            </Grid>
            <Grid item xs={12} lg={7} sm={7} md={7} align="right">
              <Box style={{ overflow: "hidden", padding: "100px 0" }}>
                <AnimationOnScroll animateIn="animate__fadeInRight">
                  <Box className="displayEnd circle moveTop">
                    <img
                      src="images/circle.png"
                      alt="images"
                      style={{ width: "80px" }}
                    />
                    <a
                      href="https://fieroscan.com/"
                      target="_blank"
                      style={{ textDecoration: "none" }}
                    >
                      <Box
                        className="globecontentBox displayStart"
                        ml={2}
                        href=""
                        // target="blank"
                        target="_blank"
                      >
                        <Typography variant="h5" color="primary">
                          Fieres Blockchain Explorer
                        </Typography>
                        <img src="images/next.png" alt="images" />
                      </Box>
                    </a>
                  </Box>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn="animate__fadeInUp ">
                  <Box className="displayEnd circle1 moveLeft">
                    <img
                      src="images/circle_1.png"
                      alt="images"
                      style={{ width: "80px" }}
                    />{" "}
                    &nbsp;&nbsp;
                    <a
                      target="_blank"
                      href="https://docs.fieres.io/"
                      style={{ textDecoration: "none" }}
                    >
                      <Box className="globecontentBox displayStart" ml={2}>
                        <Typography variant="h5" color="primary">
                          Developer Resources
                        </Typography>
                        <img src="images/next.png" alt="images" />
                      </Box>
                    </a>
                  </Box>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn="animate__fadeInRight">
                  <Box className="displayEnd circle2 moveTop">
                    <img
                      src="images/circle_2.png"
                      alt="images"
                      style={{ width: "80px" }}
                    />
                    {/* <a
                      href="https://testnet.fieroscan.com/"
                      target="_blank"
                      style={{ textDecoration: "none" }}
                    > */}
                    <Box className="globecontentBox displayStart " ml={2}>
                      <Typography variant="h5" color="primary">
                        Fieres Blockchain testnet
                      </Typography>
                      <img src="images/next.png" alt="images" />
                    </Box>
                    {/* </a> */}
                  </Box>
                </AnimationOnScroll>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}

export default Globe;
